var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer-page"},[_c('div',{staticClass:"select"},[_c('Select',{staticStyle:{"width":"330px"},attrs:{"placeholder":"请选择养殖场"},on:{"on-change":_vm.changeList}},_vm._l((_vm.mapList),function(item,index){return _c('Option',{key:index,attrs:{"value":item.id}},[_vm._v(_vm._s(item.mapName))])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }